import { NavConfig, ViewName } from '@pressreader/navigation-types';

import { IssueNavConfig } from './issue.nav.config';
import { isTextViewNavConfig, TextViewNavConfig } from './textview.nav.config';

interface PageViewNavConfig extends IssueNavConfig {
    /** Whether not to show thumbs on navigate (by default page thumbs will be shown) */
    noPageThumbs?: boolean;
    /** Translation language carried over from TextView (if user translated issue). */
    language?: string | null;
}

function isPageViewNavConfig(navConfig: NavConfig | null): navConfig is PageViewNavConfig {
    return navConfig?.viewName === ViewName.PagesView;
}

type TextOrPageViewNavConfig = TextViewNavConfig | PageViewNavConfig;

function isTextOrPageViewNavConfig(navConfig: NavConfig | null | undefined): navConfig is TextOrPageViewNavConfig {
    return isPageViewNavConfig(navConfig ?? null) || isTextViewNavConfig(navConfig ?? null);
}

export { isPageViewNavConfig, isTextOrPageViewNavConfig, PageViewNavConfig, TextOrPageViewNavConfig };
